import { SectionCard } from "@/components/common/SectionCard";
import { nameForPlatformProfile, type PlatformProfileRow } from "./platformPanelTypes";

type UsersTabProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  p: any;
  canMutate: boolean;
};

export function PlatformPanelUsersTab({ p, canMutate }: UsersTabProps) {
  return (
    <>
      <SectionCard
        title="Search users (cross-org)"
        description="Find a user by email, full name, or display name across every org you can see."
      >
        <div className="flex flex-col sm:flex-row gap-2">
          <input
            className="flex-1 text-sm border border-gray-300 rounded-lg px-3 py-2 dark:border-zinc-600 dark:bg-zinc-900 dark:text-zinc-100"
            placeholder="email, full name, display name"
            value={p.query}
            onChange={(e) => p.setQuery(e.target.value)}
          />
          <button
            type="button"
            onClick={() => void p.runSearch()}
            className="px-3 py-2 rounded-lg bg-indigo-600 text-white text-sm hover:bg-indigo-700 disabled:opacity-60"
            disabled={p.loading}
          >
            Search
          </button>
        </div>
      </SectionCard>

      <SectionCard title={`Results (${p.searchResults.length})`}>
        <div className="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-zinc-700 dark:bg-zinc-900/50">
          <div className="divide-y divide-gray-100 dark:divide-zinc-800">
            {p.searchResults.map((prof: PlatformProfileRow) => {
              const orgId = prof.primary_organization_id || "";
              const orgName = orgId ? (p.orgById.get(orgId)?.name ?? orgId) : "unknown";
              return (
                <div key={prof.id} className="px-4 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                  <div>
                    <div className="font-medium text-gray-900 dark:text-zinc-100">{nameForPlatformProfile(prof)}</div>
                    <div className="text-sm text-gray-600 dark:text-zinc-300">{prof.email}</div>
                    <div className="text-xs text-gray-500 mt-1 dark:text-zinc-400">
                      status: {prof.access_status ?? "?"} \u2022 org: {orgName}
                    </div>
                  </div>

                  {canMutate && orgId ? (
                    <div className="flex flex-wrap items-center gap-2">
                      <button
                        type="button"
                        onClick={() => void p.doApproveAssign(prof.id, orgId, "sales")}
                        title="Sets access status to approved and creates an active org membership with role = sales"
                        className="px-3 py-2 rounded-lg bg-emerald-600 text-white text-sm hover:bg-emerald-700 disabled:opacity-60"
                        disabled={p.loading}
                      >
                        Approve + Sales
                      </button>
                      <button
                        type="button"
                        onClick={() => void p.doBlock(prof.id, orgId, "Blocked by platform operator")}
                        className="px-3 py-2 rounded-lg bg-amber-600 text-white text-sm hover:bg-amber-700 disabled:opacity-60"
                        disabled={p.loading}
                      >
                        Block
                      </button>
                    </div>
                  ) : null}
                </div>
              );
            })}
            {p.searchResults.length === 0 ? (
              <div className="px-4 py-4 text-sm text-gray-600 dark:text-zinc-300">No results yet.</div>
            ) : null}
          </div>
        </div>
      </SectionCard>
    </>
  );
}
